// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1StatesCreateSchema = z.object({
  state: z.object({
    name: z.coerce.string().min(1).max(100),
    icon: z.coerce.string().max(100).nullish(),
    color: z.coerce.string().max(10).nullish(),
    billed: z.boolean().nullish(),
    locked: z.boolean().nullish(),
  }),
});
